import SurveyTestForm from '../surveyTestForm';
import PropTypes from 'prop-types';

export function SurveyMeasures({ clientProductUuid, handleChangeMode }) {
  return (
    <div>
      <SurveyTestForm
        clientProductUuid={clientProductUuid}
        handleChangeMode={handleChangeMode}
      ></SurveyTestForm>
    </div>
  );
}

SurveyMeasures.propTypes = {
  clientProductUuid: PropTypes.string,
  handleChangeMode: PropTypes.func
};
